import React from "react";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { Pressable } from "react-native";
import { GlobalStyles, Transition } from "../style/Style";

interface ButtonProps {
    icon: JSX.Element;
    onPress: () => void;
}

export const BackButton: React.FC<ButtonProps> = ({ icon, onPress }) => {
    const styles = useDynamicStyles(generateStyles);

    return (
        <Pressable style={[styles.button, Transition()]} onPress={onPress}>
            {icon}
        </Pressable>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        button: {
            width: 30,
            height: 30,
            borderRadius: "100%",
            flexShrink: 0,
            padding: 5,
            marginRight: 10,
            marginTop: 10,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.DEFAULT_NAVIGATION_BUTTON_BACKGROUND),
        },
        active: {
            backgroundColor: () => EStyleSheet.value(GlobalStyles.ACCENT_COLOUR),
        },
    });
};
